import { useTranslation } from "react-i18next";
import MapTable from "./MapTable";
import MapTablesEmpty from "./MapTablesEmpty";
import MapTop from "./MapTop";
import { MapsMenuProps } from "./MapsMenu";

const MapTables = ({
  tablePropertyName,
  editable,
  tables,
  table,
  setTable,
  showMapName = false,
}: MapsMenuProps) => {
  const { t } = useTranslation("", { keyPrefix: "maps" });
  const hasTables = tables.length !== 0;
  return (
    <div className="flex-[1_0_auto] my-[1rem] bg-[white] rounded-[0.4rem] border-[1px_solid] p-[0.5rem_1rem] border-[grey-blue-light]">
      <MapTop editable={editable} />
      <div className="overflow-y-scroll h-[48.4rem]">
        {!hasTables ? (
          <MapTablesEmpty />
        ) : (
          tables?.map((t) => (
            <MapTable
              showMapName={showMapName}
              editable={editable}
              isActive={t[tablePropertyName] === table}
              onClick={() => setTable(t[tablePropertyName])}
              key={t.item_id}
              table={t}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default MapTables;
